<template>
  <!--  https://jsfiddle.net/mani04/bgzhw68m/-->
  <div>
    <input
      type="text"
      class=""
      v-bind:class="[
        blue ? 'blue-input' : tableFormat ? 'optim-input' : 'custom-input',
        borderBlue ? 'bdr-expo' : '',
        borderYellow ? 'bdr-warn' : '',
      ]"
      :style="fontSize ? { fontSize: fontSize } : {}"
      :disabled="deactivate"
      v-model.lazy="displayValue"
      @blur="isInputActive = false"
      @focus="isInputActive = true"
    />
  </div>
</template>

<script>
export default {
  name: "InputNumber",
  data() {
    return {
      isInputActive: false,
    };
  },
  props: {
    blue: { required: false, type: Boolean, default: false },
    borderBlue: { required: false, type: Boolean, default: false },
    borderYellow: { required: false, type: Boolean, default: false },
    deactivate: { required: false, type: Boolean, default: false },
    fontSize: { type: String, required: false },
    pasted: { required: false },
    readValue: { required: false, type: Boolean, default: false },
    tableFormat: { required: false, type: Boolean, default: false },
    value: { required: true },
  },
  watch: {
    value(val) {
      if (this.readValue === true) {
        this.displayValue = val.toString();
      }
    },
  },
  computed: {
    displayValue: {
      get: function() {
        if (this.isInputActive) {
          // Cursor is inside the input field. Format display value for user
          return this.value.toString();
        } else {
          if (this.pasted) {
            let val = this.value;
            if (typeof val === "number") {
              val = val.toString();
            }
            return val.replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
          } else {
            // User is not modifying now. Format display value for user interface
            return Number.parseFloat(this.value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
          }
        }
      },
      set: function(modifiedValue) {
        // Recalculate value after ignoring "$" and "," in user input
        let newValue = parseFloat(modifiedValue.replace(/[^\d.-]/g, ""));
        // Ensure that it is not NaN
        if (Number.isNaN(newValue)) {
          newValue = 0;
        }
        // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
        // $emit the event so that parent component gets it
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
